/* @flow */

import { transparentize } from 'polished';

export default {
  root: {
    display: 'flex',
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flex: 1,

    minWidth: 0,
    marginLeft: '0.5em',

    lineHeight: 1.2,
  },
  names: {
    overflow: 'hidden',

    fontSize: 15,
    fontWeight: 500,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  details: {
    overflow: 'hidden',

    color: transparentize(0.5, '#363739'),

    fontSize: 13,
    fontWeight: 500,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};
